module.exports = __webpack_public_path__ + "img/card_right_decoration.79c64d16.png";